import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Service worker
import * as serviceWorker from './common/serviceWorker';

// App
import App from './App';
import configureStore from './store'
import history from './helpers/history';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>, 
  document.getElementById('root'));

serviceWorker.unregister();